import { render, staticRenderFns } from "./SelectedAreaComponent.vue?vue&type=template&id=598c742e&"
import script from "./SelectedAreaComponent.vue?vue&type=script&setup=true&lang=ts&"
export * from "./SelectedAreaComponent.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports